import { Component } from '@angular/core';

@Component({
  selector: 'building',
  templateUrl: './building.component.html'
})
export class BuildingComponent { }
